import React from 'react';
import './App.css';
import { HashRouter as Router, Route } from 'react-router-dom';
import Home from './Screens/Home';
import Cloud from './Screens/Cloud';
import Store from './Screens/Store';
import Licence from './Screens/Licence';

function App() {
  return (
    <Router>
      <Route path="/" exact component={Home} />
      <Route path="/cloud" component={Cloud} />
      <Route path="/store" component={Store} />
      <Route path="/licence" component={Licence} />
    </Router>
  );
}

export default App;
